import { Button, Checkbox, Input, Select, Space } from "antd";
import { PlusOutlined, SettingOutlined } from "@ant-design/icons";

function ControlBox ({stateHandler, posGroup, filters, languageGroup, curLanguage}) {

  const cefrGroup = [
    {value:"A0", label: "A0"},
    {value:"A1", label: "A1"},
    {value:"A2", label: "A2"},
    {value:"B1", label: "B1"},
    {value:"B2", label: "B2"},
    {value:"C1", label: "C1"},
    {value:"C2", label: "C2"},
  ]
  const posFilterHandler = (value) => {
    stateHandler("posFilter", value)
  }

  const cefrFilterHandler = (value) => {
    stateHandler("cefrFilter", value)
  }

  const languageHandler = (value) => {
    stateHandler("curLanguage", value)
  }

  const onSearchHandler = (value) => {
    stateHandler("searchFilter", value)
  }

  const checkHandler = (e) => {
    const checked = e.target.checked
    stateHandler("checkFilter", !filters.checkFilter)
  }

  return (
    <Space wrap style={{justifyContent: "end"}}>
      <Input.Search
        placeholder="영어 문장을 입력하세요."
        onSearch={onSearchHandler}
        allowClear={true}
        style={{
          width: 220,
          marginLeft: "5px",
        }}
      />
      <Select
        options={[{ value: "all", label: "품사: 전체" }, ...posGroup]}
        style={{ width: 100, textAlign: "left", fontSize:"12px" }}
        defaultValue="all"
        value={filters.posFilter}
        onChange={posFilterHandler}
      ></Select>
      <Select
        options={[{ value: "all", label: "CEFR 레벨: 전체" }, ...cefrGroup]}
        style={{ width: 170, textAlign: "left", fontSize:"12px" }}
        defaultValue="all"
        value={filters.cefrFilter}
        onChange={cefrFilterHandler}
      ></Select>
      <Select
        options={languageGroup}
        style={{ width: 100, textAlign: "left", fontSize:"12px" }}
        defaultValue="L0010"
        value={curLanguage}
        onChange={languageHandler}
      ></Select>
      {filters.checkFilter === undefined ? null : <Checkbox checked={filters.checkFilter} onChange={checkHandler}>이미 포함된 단어도 검색</Checkbox>}
    </Space>
  )
}

export default ControlBox